exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bindCehicleActivityBox {\n  width: 3.75rem;\n  height: 8.72rem;\n  background: url(" + require("./image/bg.png") + ") no-repeat center 0;\n  background-size: contain;\n  padding-top: 5.26rem;\n  overflow: hidden;\n}\n.bindCehicleActivityBox .reward_3_row {\n  background: url(" + require("./image/btn.png") + ") no-repeat center 0;\n  background-size: contain;\n  width: 2.27;\n  height: 0.46rem;\n  -webkit-animation: btn 0.5s steps(2) infinite;\n          animation: btn 0.5s steps(2) infinite;\n}\n@-webkit-keyframes btn {\n  100% {\n    -webkit-transform: translateY(-10px);\n            transform: translateY(-10px);\n  }\n}\n@keyframes btn {\n  100% {\n    -webkit-transform: translateY(-10px);\n            transform: translateY(-10px);\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/bindCehicleActivity/index.less
// module id = 417
// module chunks = 0